module.exports = __webpack_public_path__ + "static/media/team-6.3f9dc065.jpg";